import React from "react";

const About = () => {
  return (
    <>
      <div className="container overflow-hidden relative py-12 mx-auto px-4 md:px-12">
        <div className="pb-4">
          <h2 style={{fontFamily:"Dancing Script,cursive", color:"#009688 "}} className="text-3xl bold mb-6 font-commerce w-fit relative before:content-[''] before:absolute before:w-full before:bottom-0 before: before:h-[1px] before:left-0">
            About us
          </h2>
          <p
            className="leading-[2]"
            style={{opacity: 1,transform: 'translateX(0px) translateZ(0px)'}}
          >
            <span style={{color:"#009688 "}} className="font-bold text-palistine  ">
              E-Commerce
            </span>{" "}
            is an easy and secure platform for people to discover and shop the
            products they love. With fast delivery, easy payment and return
            options and a 24-hour customer service, find everything you need at
            competitive prices. All our products are backed by our authenticity
            promise and{" "}
            <span style={{color:"#009688 "}} className="font-bold text-palistine ">
              E-Commerce
            </span>{" "}
            warranty.
          </p>
        </div>
        <div className="mt-10 px-4 md:px-12">
          <h2
            className="text-2xl font-commerce gradient_palistine w-fit border-b border-palistine dark:border-palistineDark"
            style={{opacity: 1,transform: 'translateX(0px) translateZ(0px)' , fontFamily:"Dancing Script,cursive", color:"#009688 "}}
          >
            What is on the site?
          </h2>
          <div>
            <p className="mt-4 mb-8 text-base" style={{opacity: 1,transform: 'none' }}>
              Here is summary of what exists
            </p>
            <ul
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-10 w-[80%] mx-auto md:w-auto "
              style={{opacity: 1}}
            >
              <li
                className="bg-white border border-slate-100  rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#128c7e"
                    fill="#128c7e"
                    stroke-width="0"
                    viewBox="0 0 448 512"
                    className="text-palistine "
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2 ">
                  User
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Manage your profile or even delete it.
                </p>
              </li>
              <li
                className="bg-white   border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="currentColor"
                    fill="red"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    className="text-red"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Wishlist
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Responsible for managing your favorite products.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#aab8c2"
                    fill="#aab8c2"
                    stroke-width="0"
                    viewBox="0 0 576 512"
                    className="text-secondHeader"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Cart
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Review your products before buying them.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#32e5ff"
                    fill="#32e5ff"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    className="text-blue"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 464c22.779 0 41.411-18.719 41.411-41.6h-82.823c0 22.881 18.633 41.6 41.412 41.6zm134.589-124.8V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2s-31.059 13.518-31.059 31.2v14.559c-59.015 13.523-103.53 67.601-103.53 131.041v114.4L80 380.8v20.8h352v-20.8l-41.411-41.6z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Notifications
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Watching your profile updates.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#ff9900"
                    fill="#ff9900"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    className="text-orange"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Feltering
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Filter products and the filtering isn't changing when you are
                  taking the link to your friend or anybody else.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#88ff00"
                    fill="#88ff00"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    className="text-palistine "
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 23c-35 0-62 17.92-79.3 41.71-11.9 16.38-19.6 35.49-23.2 54.29H172c3.4-15.2 9.9-30.77 19.3-43.71C206 55.08 227 41 256 41s50 14.08 64.7 34.29c9.4 12.94 15.9 28.51 19.3 43.71h18.5c-3.6-18.8-11.3-37.91-23.2-54.29C318 40.92 291 23 256 23zM88.25 137L57.81 487H454.2l-30.4-350H88.25zM160 160a16 16 0 0 1 16 16 16 16 0 0 1-16 16 16 16 0 0 1-16-16 16 16 0 0 1 16-16zm192 0a16 16 0 0 1 16 16 16 16 0 0 1-16 16 16 16 0 0 1-16-16 16 16 0 0 1 16-16z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Orders
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  Manage the orders you have created, whether you want to delete
                  them or track their progress.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#0a66c2"
                    fill="#0a66c2"
                    stroke-width="0"
                    version="1.1"
                    viewBox="0 0 17 17"
                    className="text-blue"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g></g>
                    <path d="M13 8h1c0 2.481-2.019 4.5-4.5 4.5s-4.5-2.019-4.5-4.5h1c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5zM7.5 6.5c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1zM11.5 6.5c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1zM17 7.5c0 4.136-3.364 7.5-7.5 7.5-1.34 0-2.648-0.359-3.803-1.041l-5.5 2.843 2.843-5.499c-0.681-1.155-1.040-2.463-1.040-3.803 0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5zM16 7.5c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5c0 1.244 0.358 2.459 1.036 3.511l0.157 0.243-1.664 3.218 3.217-1.664 0.243 0.157c1.053 0.677 2.266 1.035 3.511 1.035 3.584 0 6.5-2.916 6.5-6.5z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Products comments
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  To share your opinion about the product you have purchased,
                  this section becomes available after the purchase is complete.
                </p>
              </li>
              <li
                className="bg-white  shadow-box border border-slate-100 rounded-md p-4 flex items-center justify-start flex-col gap-2 text-center transition-all duration-300 hover:-translate-y-2"
                style={{opacity: 1}}
              >
                <p className="text-3xl">
                  <svg
                    stroke="#c20a60"
                    fill="#c20a60"
                    stroke-width="0"
                    viewBox="0 0 24 24"
                    className="text-orange"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"></path>
                  </svg>
                </p>
                <h3 className="font-bold text-lg text-gray-700 py-2">
                  Interact
                </h3>
                <p className="text-lightmodeColor dark:text-darkmodeColor">
                  By sending emails to your email address, we keep you informed
                  about anything related to your account and your orders.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
